import { ReactNode, useMemo, useState } from "react";
import { useDebounce } from "@jugl-web/utils";
import {
  InvoicesItemsPageContext,
  InvoicesItemsPageContextType,
} from "./InvoicesItemsPageContext";

interface ComponentProps {
  children: ReactNode;
}

export const InvoicesItemsPageProvider = ({ children }: ComponentProps) => {
  const [searchQuery, setSearchQuery] = useState<string | undefined>(undefined);
  const [filters, setFilters] = useState<Record<string, string>>({});

  const debouncedSearchQuery = useDebounce(searchQuery, 500) as
    | string
    | undefined;

  const value: InvoicesItemsPageContextType = useMemo(
    () => ({
      searchQuery: debouncedSearchQuery,
      immediateSearchQuery: searchQuery,
      setSearchQuery,
      filters,
      setFilters,
    }),
    [debouncedSearchQuery, searchQuery, setSearchQuery, filters, setFilters]
  );

  return (
    <InvoicesItemsPageContext.Provider value={value}>
      {children}
    </InvoicesItemsPageContext.Provider>
  );
};
